import { DateTimeParseException, LocalDate } from '@js-joda/core';
import { Effect, Option, Schema, SchemaGetter, SchemaIssue } from 'effect';

import { formatUnknown } from '../helper';

/**
 * Validates ISO 8601 date strings (YYYY-MM-DD) using JS-Joda LocalDate.parse()
 * to ensure the date is actually valid (e.g., rejects 2024-02-30, 2024-13-01).
 *
 * This provides runtime validation that goes beyond regex pattern matching.
 *
 * Decode: `"2024-12-10"` → `"2024-12-10"` (validates via LocalDate.parse)
 * Encode: `"2024-12-10"` → `"2024-12-10"`
 */
export const DateValidatedIsoString = Schema.String.pipe(
  Schema.decodeTo(Schema.String, {
    decode: SchemaGetter.transformEffect((input) =>
      Effect.try({
        try: () => LocalDate.parse(input),
        catch: (e) =>
          new SchemaIssue.InvalidValue({
            message:
              e instanceof DateTimeParseException ? e.message : `Invalid date value: ${input}`,
          }),
      }).pipe(
        Effect.mapBoth({
          onSuccess: (localDate) => localDate.toString(),
          onFailure: (_e) =>
            new SchemaIssue.InvalidValue({
              message: `Hodnota ${formatUnknown(input)} není platné datum.`,
            }),
        })
      )
    ),
    encode: SchemaGetter.passthrough(),
  })
);

export type DateValidatedIsoString = Schema.Schema.Type<typeof DateValidatedIsoString>;
